import { useEffect, useState } from "react";

// ui
import { Box } from "@mui/material";

// Table
import { ConstTable } from "../component/Table";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataDetailModal } from "../component/detail/DataDetailModal";
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModal } from "../component/DataAddModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { PostCSVModal } from "../component/PostCSVModal";
import { ProductServiceStartStopModal } from "../component/tableFunction/ProductServiceStartStopModal";
import { DeletePaymentModal } from "../component/tableFunction/DeletePaymentModal";

// jotai
import { useAtomValue, useSetAtom } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getProducts,
  getProduct,
  postProduct,
  putProduct,
  putProductNoEntryFlg,
} from "../api/product";
import { postHighRankCompany } from "../api/highRankCompany";
import { getProductListIDs, postProductListID } from "../api/productListID";
import { putListID } from "../api/entrySaleCompanyPaymentListID";
import { getProductListIDGroups } from "../api/productListIDGroup";
import {
  getProductPaymentMethods,
  putProductPaymentMethod,
  postProductPaymentMethod,
} from "../api/productPaymentMethod";
import {
  getProductCancellSMSs,
  getProductCancellSMS,
  putProductCancellSMS,
  postProductCancellSMS,
  deleteProductCancellSMS,
} from "../api/productCancellSMS";
import {
  getProductTossUpSaleCompanys,
  postProductTossUpSaleCompany,
} from "../api/productTossUpSaleCompany";
import {
  getProductEntrySaleCompanys,
  postProductEntrySaleCompany,
} from "../api/productEntrySaleCompany";
import { getPresignedPostCSV, postPresignedPost } from "../api/presignedURL";
import {
  getSerchHighRankCompanys,
  getSerchCategorys,
  getSerchProducts,
  getSerchSaleCompanys,
} from "../api/serch";

// InterFace
import { productTableColumn } from "../config/product";
import { highRankCompanyTableColumn } from "../config/highRankCompany";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

const postCSVColumnListID = ["上位店名", "商材名", "グループ名", "リストID"];

function Product() {
  const setIsLoading = useSetAtom(AppAtoms.isLoading);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const loginUser = useAtomValue(AppAtoms.loginUser);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "上位店新規登録",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "商材新規登録",
    },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "リストID登録CSV取込",
    },
  ];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "商材新規登録") {
      setProductAddModal(true);
    }
    if (addDataName === "上位店新規登録") {
      setOnDataAddModalHighRankCompany(true);
    }
  }, [addDataName]);

  useEffect(() => {
    if (addCSVDataName === "リストID登録CSV取込") {
      setPostListIDCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
  }, [addCSVDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name === "リストIDグループ一覧") {
      getSubtableDataProductListIDGroup();
    }
    if (getSubTableName.name === "支払方法一覧") {
      getSubtableDataProductPaymentMethod();
    }
    if (getSubTableName.name === "解約SMS一覧") {
      getSubtableDataCancellSMS();
    }
    if (getSubTableName.name === "トスアップパートナー一覧") {
      getSubtableDataProductTossUpSaleCompanys();
    }
    if (getSubTableName.name === "エントリーパートナー一覧") {
      getSubtableDataProductEntrySaleCompanys();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの詳細取得
  const [getSubTableDetail, setGetSubTableDetail] = useState<{
    name: string;
    key: { [key: string]: string };
    dataDetail: {
      [key: string]:
        | number
        | string
        | { [key: string]: string | number }[]
        | { [key: string]: string | string[] };
    } | null;
  }>({
    name: "",
    key: {},
    dataDetail: null,
  });
  useEffect(() => {
    if (getSubTableDetail.name === "解約SMS詳細") {
      getSubtableDataDetailCancellSMS();
    }
  }, [getSubTableDetail.name, getSubTableDetail.key]);

  // サブテーブルの一覧をメインテーブルの詳細表示（エントリーフォーム用）
  const [getSubMainTableDetail, setGetSubMainTableName] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {}, [getSubMainTableDetail.name, getSubMainTableDetail.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubTableAdd.name === "支払方法追加") {
      openModalSubtableDataAddProductPaymentMethod();
    }
    if (getSubTableAdd.name === "解約SMS追加") {
      openModalSubtableDataAddCancellSMS();
    }
    if (getSubTableAdd.name === "トスアップパートナー追加") {
      openModalSubtableDataAddProductTossUpSaleCompany();
    }
    if (getSubTableAdd.name === "エントリーパートナー追加") {
      openModalSubtableDataAddProductEntrySaleCompany();
    }
  }, [getSubTableAdd.name, getSubTableAdd.row]);

  // サブサブテーブルデータの一覧取得
  const [getSubSubTableName, setGetSubSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubSubTableName.name === "リストID一覧") {
      getSubSubtableDataListID();
    }
  }, [getSubSubTableName.name, getSubSubTableName.key]);

  // サブテーブルデータの登録
  const [getSubSubTableAdd, setGetSubSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubSubTableAdd.name === "リストID追加") {
      openModalSubSubtableDataAddListID();
    }
  }, [getSubSubTableAdd.name, getSubSubTableAdd.row]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (tableOriginalFunc.name === "取扱い停止・再開") {
      setStartStopDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (tableOriginalFunc.name === "解約SMS一覧") {
      setDeleteCancellSMSInf({
        status: "open",
        name: "解約SMSの削除",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
  }, [tableOriginalFunc.name, tableOriginalFunc.key]);

  // 検索欄、テーブル等の高さ
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : "calc(100vh - 110px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone]);
  const [serchOpen, setSerchOpen] = useState(false);
  const [aiChatOpen, setAiChatOpen] = useState(false);

  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const serchColumn = productTableColumn.dataColumn.reduce((column, difine) => {
    if (difine.serch === true) {
      if (difine.serchType === "date") {
        return {
          ...column,
          [difine.key + "_start"]: "",
          [difine.key + "_end"]: "",
          no_entry_flg: "通常",
        };
      } else if (difine.serchType === "payment_year_month") {
        return {
          ...column,
          payment_year: thisYear.toString(),
          payment_month: thisMonth.toString(),
          no_entry_flg: "通常",
        };
      } else {
        return {
          ...column,
          [difine.key]: "",
          no_entry_flg: "通常",
        };
      }
    } else {
      return {
        ...column,
        no_entry_flg: "通常",
      };
    }
  }, {});
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getProducts({
      ...serchString,
      displayNumber,
      pageNumber,
    });
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.products);
      const countProducts = Number(fetchData.countProducts);
      setTotalCount(countProducts);
      setMaxPageNumber(Math.ceil(countProducts / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  // 商材詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string | { [key: string]: string | number }[];
  } | null>(null);

  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const dataDetail = await getProduct(id);
    setDataDetail(dataDetail);
    if (!edit) {
      setIsLoading(false);
    }
  }
  // 商材編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);
  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      const putResponce = await putProduct(editData);
      await getDataDetail({ id }, true);
      await getTableData(true);
      setEditData({
        ...editData,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 商材新規作成
  const addProductColumns = productTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.add) {
        if (difine.key === "payment_method") {
          return {
            ...column,
            [difine.key]: [""],
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {}
  );
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");
  const [addProduct, setAddProduct] = useState<{
    [key: string]: string | boolean | any[];
  }>(addProductColumns);
  const [onProductAddModal, setProductAddModal] = useState(false);

  async function postAddProduct() {
    setIsLoading(true);
    setProductAddModal(false);
    const postResponce = await postProduct(addProduct);
    if (postResponce === "success") {
      await getTableData(true);
      await getProductList();
      setAddProduct(addProductColumns);
      setOnDataAddModalResult("success");
    } else {
      setProductAddModal(true);
      setOnDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 上位店新規登録
  const addDataColumns = highRankCompanyTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.add) {
        if (
          difine.addType === "company" &&
          loginUser?.authority === "パートナー"
        ) {
          return {
            ...column,
            sale_company_id: "dummy_id",
            sale_company_id_name: loginUser?.company,
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {}
  );
  const [addDataHighRankCompany, setAddDataHighRankCompany] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumns);
  const [onDataAddModalHighRankCompany, setOnDataAddModalHighRankCompany] =
    useState(false);
  async function postAddDataHighRankCompany() {
    setIsLoading(true);
    setOnDataAddModalHighRankCompany(false);
    const postResponce = await postHighRankCompany(addDataHighRankCompany);
    if (postResponce === "success") {
      getHighRankCompanyList();
      await getTableData(true);
      setAddDataHighRankCompany(addDataColumns);
      setOnDataAddModalResult("success");
    } else {
      setOnDataAddModalHighRankCompany(true);
      setOnDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // リストIDグループ一覧取得
  async function getSubtableDataProductListIDGroup() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getProductListIDGroups(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 支払方法一覧取得
  async function getSubtableDataProductPaymentMethod() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getProductPaymentMethods(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 支払方法追加
  const addDataColumnsProductPaymentMethod =
    productTableColumn.subTable[1].subDataColumn.reduce((column, difine) => {
      if (difine.add) {
        if (difine.addType === "date") {
          return {
            ...column,
            [difine.key + "_year"]: thisYear.toString(),
            [difine.key + "_month"]: thisMonth.toString(),
            [difine.key + "_date"]: "1",
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    }, {});
  const [addDataProductPaymentMethod, setAddDataProductPaymentMethod] =
    useState<{
      [key: string]: string | boolean | any[];
    }>(addDataColumnsProductPaymentMethod);
  const [
    onDataAddModalProductPaymentMethod,
    setOnDataAddModalProductPaymentMethod,
  ] = useState(false);
  async function openModalSubtableDataAddProductPaymentMethod() {
    let _addDataProductPaymentMethod = addDataProductPaymentMethod;
    productTableColumn.subTable[1].subDataColumn.map((difine) => {
      if (difine.add && getSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataProductPaymentMethod[difine.key] =
            getSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableSubId") {
          _addDataProductPaymentMethod[difine.key] =
            getSubTableAdd.row[difine.key].toString();
        } else if (difine.addType === "tableData") {
          _addDataProductPaymentMethod[difine.key] = getSubTableAdd.row[
            difine.key
          ] as string;
        }
      }
    });
    setAddDataProductPaymentMethod(_addDataProductPaymentMethod);
    if (getSubTableAdd.row) {
      setOnDataAddModalProductPaymentMethod(true);
    }
  }
  async function postAddDataProductPaymentMethod() {
    setIsLoading(true);
    setOnDataAddModalProductPaymentMethod(false);
    const postResponce = await postProductPaymentMethod(
      addDataProductPaymentMethod
    );
    if (postResponce === "success") {
      if (getSubTableName.name == "支払方法一覧") {
        await getSubtableDataProductPaymentMethod();
      }
      await getTableData(true);
      setAddDataProductPaymentMethod(addDataColumnsProductPaymentMethod);
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalProductPaymentMethod(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 支払方法ダイレクト編集
  const [editDataProductPaymentMethod, setEditDataProductPaymentMethod] =
    useState<EditDataDifine | null>(null);
  async function putEditSubtableDataDirectProductPaymentMethod() {
    if (editDataProductPaymentMethod !== null) {
      setIsLoading(true);
      setEditDataProductPaymentMethod({
        ...editDataProductPaymentMethod,
        status: "editing",
      });
      const putResponce = await putProductPaymentMethod(
        editDataProductPaymentMethod
      );
      if (putResponce == "success") {
        await getSubtableDataProductPaymentMethod();
      }
      setEditDataProductPaymentMethod({
        ...editDataProductPaymentMethod,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 解約SMS一覧取得
  async function getSubtableDataCancellSMS() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getProductCancellSMSs(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 解約SMS詳細取得
  async function getSubtableDataDetailCancellSMS() {
    if (getSubTableDetail.key.id) {
      setIsLoading(true);
      const dataDetail = await getProductCancellSMS(getSubTableDetail.key.id);
      setGetSubTableDetail({
        ...getSubTableDetail,
        dataDetail,
      });
      setIsLoading(false);
    }
  }

  // 解約SMS編集
  const [editDataDetailCancellSMS, setEditDataDetailCancellSMS] =
    useState<EditDataDifine | null>(null);
  async function putEditDataDetailCancellSMS() {
    if (editDataDetailCancellSMS !== null) {
      setIsLoading(true);
      setEditDataDetailCancellSMS({
        ...editDataDetailCancellSMS,
        status: "editing",
      });
      const putResponce = await putProductCancellSMS(editDataDetailCancellSMS);
      if (putResponce == "success") {
        await getSubtableDataCancellSMS();
        await getSubtableDataDetailCancellSMS();
      }
      setEditDataDetailCancellSMS({
        ...editDataDetailCancellSMS,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 解約SMS新規登録
  const addDataColumnsCancellSMS =
    productTableColumn.subTable[2].subDataColumn.reduce(
      (column, difine) => {
        if (difine.add) {
          return { ...column, [difine.key]: "" };
        }
        return { ...column };
      },
      {}
    );
  const [addDataCancellSMS, setAddDataCancellSMS] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumnsCancellSMS);
  const [onDataAddModalCancellSMS, setOnDataAddModalCancellSMS] = useState(false);
  async function openModalSubtableDataAddCancellSMS() {
    let _addDataCancellSMS = addDataCancellSMS;
    productTableColumn.subTable[2].subDataColumn.forEach((difine) => {
      if (difine.add && getSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataCancellSMS[difine.key] = getSubTableAdd.row.id.toString();
        }
      }
    });
    setAddDataCancellSMS(_addDataCancellSMS);
    if (getSubTableAdd.row) {
      setOnDataAddModalCancellSMS(true);
    }
  }
  async function postAddDataCancellSMS() {
    setIsLoading(true);
    setOnDataAddModalCancellSMS(false);
    const postResponce = await postProductCancellSMS(addDataCancellSMS);
    if (postResponce === "success") {
      await getTableData(true);
      if (getSubTableName.name === "解約SMS一覧") {
        await getSubtableDataCancellSMS();
      }
      setAddDataCancellSMS(addDataColumnsCancellSMS);
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalCancellSMS(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // 解約SMS削除
  const [deleteCancellSMSInf, setDeleteCancellSMSInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    name: string;
    message: string;
  }>({
    status: null,
    name: "",
    key: {},
    message: "",
  });
  async function deleteCancellSMSFunc() {
    setDeleteCancellSMSInf({
      ...deleteCancellSMSInf,
      status: "loading",
    });
    const id = deleteCancellSMSInf.key.id;
    const responce = await deleteProductCancellSMS(id);
    if (responce === "success") {
      await getTableData(false);
      await getSubtableDataCancellSMS();
      setDeleteCancellSMSInf({
        ...deleteCancellSMSInf,
        status: "success",
      });
    } else {
      setDeleteCancellSMSInf({
        ...deleteCancellSMSInf,
        status: "failed",
        message: responce ?? "",
      });
    }
  }

  useEffect(() => {
    if (deleteCancellSMSInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteCancellSMSInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteCancellSMSInf]);

  // トスアップパートナー一覧取得
  async function getSubtableDataProductTossUpSaleCompanys() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getProductTossUpSaleCompanys(
        getSubTableName.key.id
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // エントリーパートナー一覧取得
  async function getSubtableDataProductEntrySaleCompanys() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getProductEntrySaleCompanys(
        getSubTableName.key.id
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // トスアップパートナー追加
  const [addDataProductTossUpSaleCompany, setAddDataProductTossUpSaleCompany] =
    useState<{
      [key: string]: string | boolean | any[];
    }>({
      product_id: "",
      all_sale_company: [],
      select_sale_company: [],
    });
  const [
    onDataAddModalProductTossUpSaleCompany,
    setOnDataAddModalProductTossUpSaleCompany,
  ] = useState(false);
  async function openModalSubtableDataAddProductTossUpSaleCompany() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getProductTossUpSaleCompanys(
        getSubTableAdd.row.id as string
      );
      setAddDataProductTossUpSaleCompany({
        product_id: getSubTableAdd.row.id.toString(),
        all_sale_company: fetchData.saleCompanyDatas,
        select_sale_company: fetchData.sudDatas,
      });
      setOnDataAddModalProductTossUpSaleCompany(true);
      setIsLoading(false);
    }
  }
  async function postAddDataProductTossUpSaleCompany() {
    setIsLoading(true);
    setOnDataAddModalProductTossUpSaleCompany(false);
    const postResponce = await postProductTossUpSaleCompany(
      addDataProductTossUpSaleCompany
    );
    if (postResponce === "success") {
      if (getSubTableName.name === "トスアップパートナー一覧") {
        await getSubtableDataProductTossUpSaleCompanys();
      }
      await getTableData(true);
      setAddDataProductTossUpSaleCompany({
        product_id: "",
        all_sale_company: [],
        select_sale_company: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalProductTossUpSaleCompany(true);
      setOnSubtableDataAddModalResult(postResponce ?? "");
    }
    setIsLoading(false);
  }

  // エントリーパートナー追加
  const [addDataProductEntrySaleCompany, setAddDataProductEntrySaleCompany] =
    useState<{
      [key: string]: string | boolean | any[];
    }>({
      product_id: "",
      all_sale_company: [],
      select_sale_company: [],
    });
  const [
    onDataAddModalProductEntrySaleCompany,
    setOnDataAddModalProductEntrySaleCompany,
  ] = useState(false);
  async function openModalSubtableDataAddProductEntrySaleCompany() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getProductEntrySaleCompanys(
        getSubTableAdd.row.id as string
      );
      setAddDataProductEntrySaleCompany({
        product_id: getSubTableAdd.row.id.toString(),
        all_sale_company: fetchData.saleCompanyDatas,
        select_sale_company: fetchData.sudDatas,
      });
      setOnDataAddModalProductEntrySaleCompany(true);
      setIsLoading(false);
    }
  }
  async function postAddDataProductEntrySaleCompany() {
    setIsLoading(true);
    setOnDataAddModalProductEntrySaleCompany(false);
    const postResponce = await postProductEntrySaleCompany(
      addDataProductEntrySaleCompany
    );
    if (postResponce === "success") {
      if (getSubTableName.name === "エントリーパートナー一覧") {
        await getSubtableDataProductEntrySaleCompanys();
      }
      await getTableData(true);
      setAddDataProductEntrySaleCompany({
        product_id: "",
        all_sale_company: [],
        select_sale_company: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalProductEntrySaleCompany(true);
      setOnSubtableDataAddModalResult(postResponce ?? "");
    }
    setIsLoading(false);
  }

  // サブサブテーブルデータの登録結果（共通）
  const [onSubSubtableDataAddModalResult, setOnSubSubtableDataAddModalResult] =
    useState("");

  // リストID一覧取得
  async function getSubSubtableDataListID() {
    if (
      getSubSubTableName.key.product_id &&
      getSubSubTableName.key.customer_list_group_id
    ) {
      setIsLoading(true);
      const fetchData = await getProductListIDs(
        getSubSubTableName.key.product_id,
        getSubSubTableName.key.customer_list_group_id
      );
      setGetSubSubTableName({
        ...getSubSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // リストID編集
  const [editDataDetailListID, setEditDataDetailListID] =
    useState<EditDataDifine | null>(null);
  async function putEditDataDetailListID() {
    if (editDataDetailListID !== null) {
      setIsLoading(true);
      setEditDataDetailListID({
        ...editDataDetailListID,
        status: "editing",
      });
      const putResponce = await putListID(editDataDetailListID);
      if (putResponce == "success") {
        await getSubSubtableDataListID();
      }
      setEditDataDetailListID({
        ...editDataDetailListID,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }
  // リストID新規登録
  const addDataColumnsListID =
    productTableColumn.subTable[0].subTable[0].subDataColumn.reduce(
      (column, difine) => {
        if (difine.add) {
          if (difine.addType === "date") {
            return {
              ...column,
              [difine.key + "_year"]: thisYear.toString(),
              [difine.key + "_month"]: thisMonth.toString(),
              [difine.key + "_date"]: "1",
            };
          } else {
            return {
              ...column,
              [difine.key]: "",
              payment_end_date_post: true,
            };
          }
        } else {
          return {
            ...column,
            payment_end_date_post: true,
          };
        }
      },
      {}
    );
  const [addDataListID, setAddDataListID] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumnsListID);
  const [onDataAddModalListID, setOnDataAddModalListID] = useState(false);
  async function openModalSubSubtableDataAddListID() {
    let _addDataListID = addDataListID;
    productTableColumn.subTable[0].subTable[0].subDataColumn.map((difine) => {
      if (difine.add && getSubSubTableAdd.row) {
        if (difine.addType === "tableId") {
          _addDataListID[difine.key] = getSubSubTableAdd.row.id.toString();
        } else if (difine.addType === "tableSubId") {
          _addDataListID[difine.key] =
            getSubSubTableAdd.row[difine.key].toString();
        } else if (difine.addType === "tableData") {
          _addDataListID[difine.key] = getSubSubTableAdd.row[
            difine.key
          ] as string;
        }
      }
    });
    setAddDataListID(_addDataListID);
    if (getSubSubTableAdd.row) {
      setOnDataAddModalListID(true);
    }
  }
  async function postAddDataListID() {
    setIsLoading(true);
    setOnDataAddModalListID(false);
    const postResponce = await postProductListID(addDataListID);
    if (postResponce === "success") {
      await getTableData(true);

      if (getSubTableName.name === "リストIDグループ一覧") {
        await getSubtableDataProductListIDGroup();
        setIsLoading(true);
      }
      if (getSubSubTableName.name === "リストID一覧") {
        await getSubSubtableDataListID();
        setIsLoading(true);
      }
      setAddDataListID(addDataColumnsListID);
      setOnSubSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalListID(true);
      setOnSubSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // サービスプラン登録CSV取込
  const [postListIDCSVStatus, setPostListIDCSVStatus] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postListIDCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postListIDCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postListIDCSVStatus]);
  async function postListIDCSV(postDatas: File) {
    setPostListIDCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostListIDCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "listID";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostListIDCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postListIDCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        if (getSubTableName.name === "リストIDグループ一覧") {
          await getSubtableDataProductListIDGroup();
          setIsLoading(true);
        }
        if (getSubSubTableName.name === "リストID一覧") {
          await getSubSubtableDataListID();
          setIsLoading(true);
        }
        setPostListIDCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postListIDCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostListIDCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postListIDCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostListIDCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 取扱い停止・再開
  const [startStopDataInf, setStartStopDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function startStopData() {
    setStartStopDataInf({
      ...startStopDataInf,
      status: "loading",
    });
    const id = startStopDataInf.key.id;
    const startStop = startStopDataInf.key.startStop;
    const responce = await putProductNoEntryFlg(id, startStop);
    if (responce == "success") {
      await getTableData(false);
      setStartStopDataInf({
        ...startStopDataInf,
        status: "success",
      });
    } else {
      setStartStopDataInf({
        ...startStopDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (startStopDataInf.status === "loading") {
      setIsLoading(true);
    } else if (startStopDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [startStopDataInf]);

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[]
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        }
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // カテゴリ一覧
  const [categoryList, setCategoryList] = useState<
    { id: number; category_name: string }[]
  >([]);
  const [categoryNameList, setCategoryNameList] = useState([""]);
  async function getCategoryList() {
    const fetchData = await getSerchCategorys();
    if (fetchData === null) {
      setCategoryList([]);
    } else if (fetchData) {
      setCategoryList(
        fetchData.categorys as {
          id: number;
          category_name: string;
        }[]
      );
      let categoryNameList = [""];
      fetchData.categorys.map(
        (company: { id: number; category_name: string }) => {
          if (!categoryNameList.includes(company.category_name)) {
            categoryNameList.push(company.category_name);
          }
        }
      );
      setCategoryNameList(categoryNameList);
    }
  }

  // 商材一覧
  const [productList, setProductList] = useState<
    { id: number; high_rank_company_id: number; product_name: string }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }[]
      );
      let productNameList = [""];
      fetchData.products.map(
        (company: {
          id: number;
          high_rank_company_id: number;
          product_name: string;
        }) => {
          if (!productNameList.includes(company.product_name)) {
            productNameList.push(company.product_name);
          }
        }
      );
      setProductNameList(productNameList);
    }
  }

  // パートナー一覧
  const [saleCompanyList, setSaleCompanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  async function getSaleCompanyList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setSaleCompanyList([]);
    } else if (fetchData) {
      setSaleCompanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[]
      );
    }
  }

  useEffect(() => {
    getHighRankCompanyList();
    getCategoryList();
    getProductList();
    getSaleCompanyList();
  }, []);

  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };

  return (
    <Box
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : (serchOpen || aiChatOpen)
          ? "calc(100% - 331px)"
          : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={[]}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
      />
      <Box style={{ display: "flex" }}>
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
              margin: isSmartPhone ? undefined : "10px 15px",
              height: isSmartPhone ? undefined : tableHeight,
              maxHeight: isSmartPhone ? undefined : tableHeight,
            }}
          >
            <ConstTable
              getTableData={getTableData}
              tableType={"main"}
              serchOpen={serchOpen}
              aiChatOpen={aiChatOpen}
              tableHeight={tableHeight}
              tableColumn={productTableColumn}
              dataColumn={[]}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={getDataDetail}
              getSubTableName={getSubTableName}
              setGetSubTableName={setGetSubTableName}
              getSubTableDetail={getSubTableDetail}
              setGetSubTableDetail={setGetSubTableDetail}
              setGetSubTableAdd={setGetSubTableAdd}
              setGetSubTableEditDirect={setEditDataProductPaymentMethod}
              getSubSubTableName={getSubSubTableName}
              setGetSubSubTableName={setGetSubSubTableName}
              getSubSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubSubTableDetail={() => {}}
              setGetSubSubTableAdd={setGetSubSubTableAdd}
              setGetSubSubTableEditDirect={setEditDataDetailListID}
              tableTitle={productTableColumn.title}
              switchTableCheckBox={() => {}}
              allCheckFlg={false}
              switchAllTableCheckBox={() => {}}
              editIDs={[]}
              setEditIDs={() => {}}
              setEditDatasName={setEditDatasName}
              setGetSubMainTableName={setGetSubMainTableName}
              setTableOriginalFunc={setTableOriginalFunc}
              sortColumn={[]}
              setSortColumn={() => {}}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={productTableColumn}
            dataColumn={[]}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={[]}
            companyGroupNameList={[]}
            highRankCompanyNameList={highRankCompanyNameList}
            categoryNameList={categoryNameList}
            productNameList={productNameList}
            accountSaleNameList={[]}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="Product"
          />
        )}
      </Box>
      <DataDetailModal
        onModal={
          dataDetail !== null &&
          ((editData !== null && editData.status !== "editing") ||
            editData === null)
        }
        swCloseModal={() => setDataDetail(null)}
        detailTitle={productTableColumn.detailTitle}
        editAuth={productTableColumn.editAuth}
        dataColumn={productTableColumn.dataColumn}
        subDataColumn={[]}
        dataDetail={dataDetail}
        setEditData={setEditData}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataEditModal
        onModal={editData !== null && editData.status !== "editing"}
        swCloseModal={() => setEditData(null)}
        editData={editData}
        setEditData={setEditData}
        putEditData={putEditData}
        groupList={[]}
        categoryList={categoryList}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataEditModal
        onModal={
          editDataProductPaymentMethod !== null &&
          editDataProductPaymentMethod.status !== "editing"
        }
        swCloseModal={() => setEditDataProductPaymentMethod(null)}
        editData={editDataProductPaymentMethod}
        setEditData={setEditDataProductPaymentMethod}
        putEditData={putEditSubtableDataDirectProductPaymentMethod}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataEditModal
        onModal={
          editDataDetailListID !== null &&
          editDataDetailListID.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailListID(null)}
        editData={editDataDetailListID}
        setEditData={setEditDataDetailListID}
        putEditData={putEditDataDetailListID}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onDataAddModalProductPaymentMethod}
        swCloseModal={() => {
          setOnDataAddModalProductPaymentMethod(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={productTableColumn.subTable[1].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={productTableColumn.subTable[1].subDataColumn}
        postAddData={postAddDataProductPaymentMethod}
        addData={addDataProductPaymentMethod}
        setAddData={setAddDataProductPaymentMethod}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalCancellSMS}
        swCloseModal={() => {
          setOnDataAddModalCancellSMS(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={productTableColumn.subTable[2].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={productTableColumn.subTable[2].subDataColumn}
        postAddData={postAddDataCancellSMS}
        addData={addDataCancellSMS}
        setAddData={setAddDataCancellSMS}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={productList}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DeletePaymentModal
        onModal={
          deleteCancellSMSInf.status !== null &&
          deleteCancellSMSInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteCancellSMSInf({
            status: null,
            name: "",
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deletePaymentInf={deleteCancellSMSInf}
        setDeletePaymentInf={setDeleteCancellSMSInf}
        deletePayment={deleteCancellSMSFunc}
      />
      <DataDetailModal
        onModal={
          getSubTableDetail.name ===
            productTableColumn.subTable[2].subTableDetailTitle &&
          getSubTableDetail.dataDetail !== null &&
          ((editDataDetailCancellSMS !== null &&
            editDataDetailCancellSMS.status !== "editing") ||
            editDataDetailCancellSMS === null)
        }
        swCloseModal={() =>
          setGetSubTableDetail({
            name: "",
            key: {},
            dataDetail: null,
          })
        }
        detailTitle={productTableColumn.subTable[2].subTableDetailTitle}
        editAuth={productTableColumn.subTable[2].subTableEditAuth}
        dataColumn={[]}
        subDataColumn={productTableColumn.subTable[2].subDataColumn}
        dataDetail={getSubTableDetail.dataDetail}
        setEditData={setEditDataDetailCancellSMS}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataEditModal
        onModal={
          editDataDetailCancellSMS !== null &&
          editDataDetailCancellSMS.status !== "editing"
        }
        swCloseModal={() => setEditDataDetailCancellSMS(null)}
        editData={editDataDetailCancellSMS}
        setEditData={setEditDataDetailCancellSMS}
        putEditData={putEditDataDetailCancellSMS}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onProductAddModal}
        swCloseModal={() => {
          setProductAddModal(false);
          setAddDataName("");
        }}
        addTitle={productTableColumn.addTitle}
        dataColumn={productTableColumn.dataColumn}
        subDataColumn={[]}
        postAddData={postAddProduct}
        addData={addProduct}
        setAddData={setAddProduct}
        companyList={[]}
        highRankCompanyList={highRankCompanyList}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={productList}
        categoryList={categoryList}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalHighRankCompany}
        swCloseModal={() => {
          setOnDataAddModalHighRankCompany(false);
          setAddDataName("");
        }}
        addTitle={highRankCompanyTableColumn.addTitle}
        dataColumn={highRankCompanyTableColumn.dataColumn}
        subDataColumn={[]}
        postAddData={postAddDataHighRankCompany}
        addData={addDataHighRankCompany}
        setAddData={setAddDataHighRankCompany}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalListID}
        swCloseModal={() => {
          setOnDataAddModalListID(false);
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={productTableColumn.subTable[0].subTable[0].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={productTableColumn.subTable[0].subTable[0].subDataColumn}
        postAddData={postAddDataListID}
        addData={addDataListID}
        setAddData={setAddDataListID}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalProductTossUpSaleCompany}
        swCloseModal={() => {
          setOnDataAddModalProductTossUpSaleCompany(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={productTableColumn.subTable[3].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={productTableColumn.subTable[3].subDataColumn}
        postAddData={postAddDataProductTossUpSaleCompany}
        addData={addDataProductTossUpSaleCompany}
        setAddData={setAddDataProductTossUpSaleCompany}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalProductEntrySaleCompany}
        swCloseModal={() => {
          setOnDataAddModalProductEntrySaleCompany(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={productTableColumn.subTable[4].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={productTableColumn.subTable[4].subDataColumn}
        postAddData={postAddDataProductEntrySaleCompany}
        addData={addDataProductEntrySaleCompany}
        setAddData={setAddDataProductEntrySaleCompany}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <DataAddModalResult
        onModal={onSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubtableDataAddModalResult("");
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubtableDataAddModalResult}
      />
      <DataAddModalResult
        onModal={onSubSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubSubtableDataAddModalResult("");
          setGetSubSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubSubtableDataAddModalResult}
      />
      <PostCSVModal
        onModal={
          postListIDCSVStatus.status !== "none" &&
          postListIDCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostListIDCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postListIDCSVStatus}
        setPostCSVStatus={setPostListIDCSVStatus}
        postCSVFunc={postListIDCSV}
        postCSVTitle={"リストID登録CSV取込"}
        postCSVColumn={postCSVColumnListID}
        postCSVColumnResult={postCSVColumnListID}
        postCSVPath="listID"
        productList={[]}
        categoryList={[]}
      />
      <ProductServiceStartStopModal
        onModal={
          startStopDataInf.status !== null &&
          startStopDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setStartStopDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        startStopDataInf={startStopDataInf}
        setStartStopDataInf={setStartStopDataInf}
        startStopData={startStopData}
      />
    </Box>
  );
}

export default Product;
